<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <!-- Site wrapper -->
    <div class="wrapper">
        <!-- Navbar -->
        <app-header></app-header>
        <!-- /.navbar -->

        <!-- Main Sidebar Container -->
        <app-sidebar [page]="'users'" [subPage]="'users'"></app-sidebar>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0">Compliance</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a [routerLink]="['']">Home</a></li>
                            <li class="breadcrumb-item active">Compliance</li>
                        </ol>
                    </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->

            <!-- Main content -->
            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'entities'" [activeSlug]="'users'"></app-module-menu>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card card-primary card-outline">
                                <img [hidden]='!loading' [class]="loading?'mx-auto d-block':''" src="assets/LoadingGIF/Rolling-1s-75px.gif">

                                <!-- Default box -->
                                <div class="card card-solid" [hidden]='loading'>
                                    <div class="card-header">
                                        <h3 class="card-title">
                                            <i class="fas fa-edit"></i>
                                            {{mainHeader}}
                                        </h3>
                                        <div class="text-right"> 
                                            <div class="btn-group">
                                                <a *ngIf="checkService.canWrite('users')" [routerLink]="" data-toggle="modal" data-target="#modal-activate"class="btn btn-danger btn-sm" type="button">Add Entity</a>&nbsp;
                                                <a [routerLink]="['/users']" class="btn btn-primary btn-sm" type="button">All</a>&nbsp;
                                                <a [routerLink]="['/users','pending']" class="btn btn-primary btn-sm" type="button">Pending KYC</a>&nbsp;
                                                <a [routerLink]="['/users','kycApproved']" class="btn btn-primary btn-sm" type="button">Approved KYC</a>&nbsp;
                                                <a [routerLink]="['/users','active']" class="btn btn-primary btn-sm" type="button">Active</a>&nbsp;
                                                <a [routerLink]="['/users','inactive']" class="btn btn-primary btn-sm" type="button">In-Active</a>&nbsp;
                                                <a [routerLink]="['/users','new']" class="btn btn-primary btn-sm" type="button">New</a>&nbsp;
                                                
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" placeholder="Search Mail">
                                                </div>
                                                <button [routerLink]="['/users/search']" class="btn btn-primary btn-sm" type="button"><i class="fas fa-search"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Country</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let userRow of userist; index as i">
                                                    <th>{{i+1}}</th>
                                                    <td><button type="button" class="btn btn-link p-0 staff-name-link" (click)="openUserDrawer(userRow)"><strong>{{printName(userRow)}}</strong></button></td>
                                                    <td>{{userRow.email}}</td>
                                                    <td>{{userRow.phone}}</td>
                                                    <td>{{userRow.country.title}}</td>
                                                    <td>
                                                        <span [class]="userRow.status.active === true ? 'badge bg-success' : userRow.status.new === true ? 'badge bg-info' : userRow.status.kycApproved === true ? 'badge bg-success' : userRow.status.inactive === true ? 'badge bg-danger' : 'badge bg-warning'" [innerHTML]="userRow.status.active === true ? 'Active' : userRow.status.new === true ? 'KYC Needed' :  userRow.status.kycApproved === true ? 'KYC Approved' : userRow.status.inactive === true ? 'Inactive' : 'KYC Submitted'"></span></td>
                                                    <td>{{userRow.created}}</td>
                                                    <td>{{userRow.lastModified}}</td>
                                                    <td>
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-secondary" title="View Details" (click)="openUserDrawer(userRow)">
                                                                <i class="fas fa-eye"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify('users')" data-toggle="modal" data-target="#modal-activate" (click)="getEdit(userRow)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <a class="btn btn-secondary" *ngIf="userRow.status.new === true" title="Complete KYC Form" [href]="[kycUrl + userRow.publicKey + '/' + publicKey]" target="_blank">
                                                                <i class="fas fa-save"></i>
                                                            </a>
                                                            <button type="button" class="btn btn-primary" *ngIf="userRow.status.new === true && checkService.canWrite('users')" title="Resend KYC Email" (click)="sendEmail(userRow, 'kyc')">
                                                                <i class="fas fa-paper-plane"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-secondary" *ngIf="userRow.status.new === true && checkService.canWrite('users')" title="Resend Account PIN" (click)="sendEmail(userRow, 'accountPin')">
                                                                <i class="fas fa-key"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify('users')" data-toggle="modal" data-target="#modal-delete" (click)="getDataFromList(userRow.lastName, userRow.ref)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="userist.length == 0">
                                                    <td colspan="9" class="text-center">No record to show</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Country</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <!-- /.card-body -->
                                    <div class="card-footer" *ngIf="userist.length > 0">
                                        <app-pagination [url]='url' [counts]='count'(refresh)="getUser($event)"></app-pagination>
                                    </div>
                                    <!-- /.card-footer -->
                                </div>
                            </div>
                        <!-- /.card -->
                        </div>
                        <!-- /.col -->
                    </div>
                <!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content -->
            <!-- /.content-wrapper -->

        </div>
        <!-- /.content-wrapper -->
        <div class="side-drawer-backdrop" *ngIf="selectedUser" (click)="closeUserDrawer()"></div>
        <aside class="side-drawer" *ngIf="selectedUser">
            <div class="side-drawer-header">
                <div class="drawer-avatar drawer-avatar-icon"><i class="fas fa-building"></i></div>
                <div class="drawer-title">
                    <h3>{{printName(selectedUser)}}</h3>
                    <p>{{selectedUser.email}} &middot; {{displayValue(selectedUser.country?.title)}}</p>
                </div>
                <span class="drawer-status" [ngClass]="selectedUser.status?.inactive === true ? 'status-warning' : ''">
                    <i class="fas fa-circle"></i> {{userStatusLabel(selectedUser)}}
                </span>
                <button type="button" class="drawer-close" aria-label="Close details" (click)="closeUserDrawer()"><i class="fas fa-times"></i></button>
            </div>
            <div class="drawer-tabs">
                <button type="button" [class.active]="selectedUserTab === 'overview'" (click)="setUserDrawerTab('overview')">Overview</button>
                <button type="button" [class.active]="selectedUserTab === 'company'" (click)="setUserDrawerTab('company')">Company</button>
                <button type="button" [class.active]="selectedUserTab === 'directors'" (click)="setUserDrawerTab('directors')">Directors</button>
                <button type="button" [class.active]="selectedUserTab === 'contacts'" (click)="setUserDrawerTab('contacts')">Contacts</button>
                <button type="button" [class.active]="selectedUserTab === 'ownership'" (click)="setUserDrawerTab('ownership')">Ownership</button>
                <button type="button" [class.active]="selectedUserTab === 'transaction'" (click)="setUserDrawerTab('transaction')">Transaction</button>
                <button type="button" [class.active]="selectedUserTab === 'compliance'" (click)="setUserDrawerTab('compliance')">Compliance</button>
                <button type="button" [class.active]="selectedUserTab === 'kyc'" (click)="setUserDrawerTab('kyc')">KYC Status</button>
                <button type="button" [class.active]="selectedUserTab === 'documents'" (click)="setUserDrawerTab('documents')">Documents</button>
            </div>
            <div class="side-drawer-body">
                <div class="drawer-loading" *ngIf="selectedUserLoading">Loading entity details...</div>
                <ng-container *ngIf="!selectedUserLoading">
                    <div class="drawer-section" *ngIf="selectedUserTab === 'overview'">
                        <div class="drawer-grid">
                            <div class="drawer-field"><span>Name</span><strong>{{printName(selectedUser)}}</strong></div>
                            <div class="drawer-field"><span>Email</span><strong>{{selectedUser.email}}</strong></div>
                            <div class="drawer-field"><span>Representative</span><strong>{{selectedUser.firstName}} {{selectedUser.lastName}}</strong></div>
                            <div class="drawer-field"><span>Phone</span><strong>{{displayValue(selectedUser.phone)}}</strong></div>
                            <div class="drawer-field"><span>Country</span><strong>{{displayValue(selectedUser.country?.title)}}</strong></div>
                            <div class="drawer-field"><span>Created</span><strong>{{selectedUser.created}}</strong></div>
                            <div class="drawer-field"><span>Last Modified</span><strong>{{selectedUser.lastModified}}</strong></div>
                        </div>
                    </div>
                    <div class="drawer-section" *ngIf="selectedUserTab === 'company'">
                        <div class="drawer-grid">
                            <div class="drawer-field"><span>Company Name</span><strong>{{displayValue(selectedUser.companyDetails?.name)}}</strong></div>
                            <div class="drawer-field"><span>Registration No</span><strong>{{displayValue(selectedUser.companyDetails?.regNo)}}</strong></div>
                            <div class="drawer-field"><span>Trade Name</span><strong>{{displayValue(selectedUser.companyDetails?.tradeName)}}</strong></div>
                            <div class="drawer-field"><span>Company Email</span><strong>{{displayValue(selectedUser.companyDetails?.email)}}</strong></div>
                            <div class="drawer-field"><span>Phone</span><strong>{{displayValue(selectedUser.companyDetails?.phone)}}</strong></div>
                            <div class="drawer-field"><span>Regulator</span><strong>{{displayValue(selectedUser.companyDetails?.regulator)}}</strong></div>
                            <div class="drawer-field drawer-field-wide"><span>Address</span><strong>{{displayValue(selectedUser.companyDetails?.address)}}</strong></div>
                            <div class="drawer-field drawer-field-wide"><span>Purpose</span><strong>{{displayValue(selectedUser.companyDetails?.purpose)}}</strong></div>
                        </div>
                    </div>
                    <div class="drawer-section" *ngIf="selectedUserTab === 'kyc'">
                        <div class="drawer-grid">
                            <div class="drawer-field"><span>Company Details</span><strong>{{documentStatusLabel(selectedUser.validation?.companyDetails?.status)}}</strong></div>
                            <div class="drawer-field"><span>Directors</span><strong>{{documentStatusLabel(selectedUser.validation?.directorDetails?.status)}}</strong></div>
                            <div class="drawer-field"><span>Contact Person</span><strong>{{documentStatusLabel(selectedUser.validation?.contactPersonDetails?.status)}}</strong></div>
                            <div class="drawer-field"><span>Ownership</span><strong>{{documentStatusLabel(selectedUser.validation?.ownershipDetails?.status)}}</strong></div>
                            <div class="drawer-field"><span>Transaction</span><strong>{{documentStatusLabel(selectedUser.validation?.transactionDetails?.status)}}</strong></div>
                            <div class="drawer-field"><span>Compliance</span><strong>{{documentStatusLabel(selectedUser.validation?.complianceDetails?.status)}}</strong></div>
                            <div class="drawer-field"><span>Uploaded Files</span><strong>{{documentStatusLabel(selectedUser.validation?.uploadFiles?.status)}}</strong></div>
                        </div>
                    </div>
                    <div class="drawer-section" *ngIf="selectedUserTab === 'directors'">
                        <div class="drawer-document-row" *ngFor="let director of selectedUser.directorDetails">
                            <div>
                                <strong>{{displayValue(director.name)}}</strong>
                                <span>{{displayValue(director.designation)}} &middot; {{displayValue(director.email)}} &middot; {{displayValue(director.phone)}}</span>
                                <span>{{displayValue(director.address)}}</span>
                            </div>
                        </div>
                        <div class="drawer-empty" *ngIf="!selectedUser.directorDetails || selectedUser.directorDetails.length === 0">No director details available.</div>
                    </div>
                    <div class="drawer-section" *ngIf="selectedUserTab === 'contacts'">
                        <div class="drawer-document-row" *ngFor="let contact of selectedUser.contactPersons">
                            <div>
                                <strong>{{displayValue(contact.name)}}</strong>
                                <span>{{displayValue(contact.designation)}} &middot; {{displayValue(contact.email)}} &middot; {{displayValue(contact.phone)}}</span>
                                <span>{{displayValue(contact.address)}}</span>
                            </div>
                        </div>
                        <div class="drawer-empty" *ngIf="!selectedUser.contactPersons || selectedUser.contactPersons.length === 0">No contact person details available.</div>
                    </div>
                    <div class="drawer-section" *ngIf="selectedUserTab === 'ownership'">
                        <div class="drawer-document-row" *ngFor="let owner of selectedUser.ownership">
                            <div>
                                <strong>{{displayValue(owner.name)}}</strong>
                                <span>{{displayValue(owner.shareholding)}}% shareholding &middot; {{owner.politicallyExposed ? 'Politically exposed' : 'Not politically exposed'}}</span>
                            </div>
                        </div>
                        <div class="drawer-empty" *ngIf="!selectedUser.ownership || selectedUser.ownership.length === 0">No ownership details available.</div>
                    </div>
                    <div class="drawer-section" *ngIf="selectedUserTab === 'transaction'">
                        <div class="drawer-grid">
                            <div class="drawer-field drawer-field-wide"><span>Origin</span><strong>{{displayValue(selectedUser.transaction?.origin)}}</strong></div>
                            <div class="drawer-field drawer-field-wide"><span>Business Purpose</span><strong>{{displayValue(selectedUser.transaction?.businessPurpose)}}</strong></div>
                            <div class="drawer-field drawer-field-wide"><span>Funds Application</span><strong>{{displayValue(selectedUser.transaction?.fundsApplication)}}</strong></div>
                            <div class="drawer-field"><span>License Required</span><strong>{{selectedUser.transaction?.license?.required ? 'Yes' : 'No'}}</strong></div>
                            <div class="drawer-field"><span>License Issuer</span><strong>{{displayValue(selectedUser.transaction?.license?.issuer)}}</strong></div>
                            <div class="drawer-field"><span>License Number</span><strong>{{displayValue(selectedUser.transaction?.license?.number)}}</strong></div>
                        </div>
                    </div>
                    <div class="drawer-section" *ngIf="selectedUserTab === 'compliance'">
                        <div class="drawer-grid">
                            <div class="drawer-field"><span>Policy</span><strong>{{selectedUser.compliance?.policy?.status ? 'Complete' : 'Pending'}}</strong></div>
                            <div class="drawer-field"><span>AML</span><strong>{{selectedUser.compliance?.aml?.status ? 'Complete' : 'Pending'}}</strong></div>
                            <div class="drawer-field"><span>Due Diligence</span><strong>{{selectedUser.compliance?.dueDilligence?.status ? 'Complete' : 'Pending'}}</strong></div>
                            <div class="drawer-field"><span>Data Privacy</span><strong>{{selectedUser.compliance?.dataPrivacy?.status ? 'Complete' : 'Pending'}}</strong></div>
                            <div class="drawer-field"><span>Dispute</span><strong>{{selectedUser.compliance?.dispute?.status ? 'Complete' : 'Pending'}}</strong></div>
                        </div>
                    </div>
                    <div class="drawer-section" *ngIf="selectedUserTab === 'documents'">
                        <div class="drawer-document-row" *ngFor="let document of selectedUser.documents">
                            <div>
                                <strong>{{document.documentType?.title || document.documentType || 'Document'}}</strong>
                                <span>{{document.label || document.created || '-'}}</span>
                            </div>
                            <a class="btn btn-sm btn-outline-primary" *ngIf="document.url" [href]="document.url" target="_blank">View</a>
                        </div>
                        <div class="drawer-empty" *ngIf="!selectedUser.documents || selectedUser.documents.length === 0">No documents uploaded.</div>
                    </div>
                </ng-container>
            </div>
        </aside>
        <app-footer></app-footer>
    </div>
    <!-- ./wrapper -->
</div>
<div class="modal fade" id="modal-activate">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Create New Entity</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="dataForm">
                <div class="form-group">
                    <label for="name">Company Name</label>
                    <input type="text" required [ngClass]="(name.invalid && (name.dirty || name.touched)) ? 'form-control is-invalid' : (name.valid)? 'form-control is-valid':'form-control'" formControlName="name" id="name" placeholder="Company name">
                    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="invalid-feedback">
                        <div *ngIf="name.errors.required">Company Name is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="lastName">Rep. Last Name</label>
                    <input type="text" required [ngClass]="(lastName.invalid && (lastName.dirty || lastName.touched)) ? 'form-control is-invalid' : (lastName.valid)? 'form-control is-valid':'form-control'" formControlName="lastName" id="lastName" placeholder="Last name">
                    <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="invalid-feedback">
                        <div *ngIf="lastName.errors.required">Entity representative Last name is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="firstName">Rep. First Name</label>
                    <input type="text" required [ngClass]="(firstName.invalid && (firstName.dirty || firstName.touched)) ? 'form-control is-invalid' : (firstName.valid)? 'form-control is-valid':'form-control'" formControlName="firstName" id="firstName" placeholder="First name">
                    <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="invalid-feedback">
                        <div *ngIf="firstName.errors.required">Entity representative First name is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="email">E-Mail</label>
                    <input type="email" required [ngClass]="(email.invalid && (email.dirty || email.touched)) ? 'form-control is-invalid' : (email.valid)? 'form-control is-valid':'form-control'" formControlName="email" id="email" placeholder="someone@example.com">
                    <div *ngIf="email.invalid && (email.dirty || email.touched)" class="invalid-feedback">
                        <div *ngIf="email.errors.required">E-Mail is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="phone">Phone Number</label>
                    <input type="text" required [ngClass]="(phone.invalid && (phone.dirty || phone.touched)) ? 'form-control is-invalid' : (phone.valid)? 'form-control is-valid':'form-control'" formControlName="phone" id="phone"  placeholder="+X (XXX) XXX XXXX" (input)="formatPhoneNumber(dataForm, 'phone')">
                    <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="invalid-feedback">
                        <div *ngIf="phone.errors.required">Phone number is required</div>
                        <div *ngIf="phone.errors.phoneNumberInvalid">Invalid phone number format. Please use +X (XXX) XXX XXXX.</div>
                    </div>
                </div>
            </form>
        </div>
        <div class="modal-footer justify-content-between">
            <input type="hidden" formControlName="ref" id="ref">
            <button type="button" class="btn btn-warning" data-dismiss="modal" (click)="onCancel()">Close</button>
            <button type="button" [disabled]="!dataForm.valid || dataForm.pending || processing" (click)="onCreate()" class="btn btn-primary">{{buttonText}}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<!-- /.modal -->
<div class="modal fade" id="modal-delete">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Delete Entity</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will remove '+docTypeName+'. This action is not reversable, are you sure you want to continue. If the user has submitted any KYC document, they will be archived?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-outline-light" (click)="deleteUser(docTypeRef)">Delete Entity</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
